import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const NebulaUltraFees = React.lazy(() =>
    import('../NebulaUltraFees')
);
const nebulaUltraFeesRoutesRegistry = [
    {
        path: PAGE_URL.NEBULA_ULTRA_FEES_PAGE,
        element: <NebulaUltraFees />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default nebulaUltraFeesRoutesRegistry;
